<template>
  <div class="admin-wrapper">
    <!-- 头部 -->
    <app-header></app-header>
    <!-- 主体部分 -->
    <app-main></app-main>
  </div>
</template>
<script>
import Header from './header'
import Main from './main'
import Footer from './footer'
export default {
  components: {
    'app-header': Header,
    'app-main': Main,
    'app-footer': Footer
  }
}
</script>
<style>
.admin-wrapper {
  position: relative;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.admin-content {
  padding: 30px;
}
/* tabs */
.admin-tabs .el-tabs__nav {
  float: right;
}
.admin-tabs .el-tabs__nav-wrap::after {
  display: none;
}
.admin-tabs .el-tabs__item {
  padding: 0;
  width: 142px;
  height: 32px;
  line-height: 30px;
  color: #333;
  text-align: center;
  background-color: #fff;
  border: 1px solid #e7e7eb;
}
.admin-tabs .el-tabs__item.is-active {
  color: #fff;
  background-color: #66b1ff;
  border: 1px solid #66b1ff;
}
.admin-tabs .el-tabs__active-bar {
  display: none;
}

/* popover */
.admin-popover {
  width: 204px;
  padding: 8px;
  overflow: hidden;
}
.admin-popover p {
  font-size: 16px;
  color: #575754;
  margin-bottom: 20px;
}
.admin-popover .el-button {
  float: left;
  min-width: 88px;
  line-height: 16px;
}
/* pager */
.admin-pager {
  clear: both;
  margin-top: 20px;
  padding: 20px 0;
  border-top: 1px solid #e7e7eb;
  text-align: center;
}
</style>
